import type { ReactElement } from 'react';

/** 첫 로딩 자리표시 — 내 견적 상세와 같은 회색 칸(머리·두 칸). 문구는 화면낭독기에만 읽힌다. */
export const MyOrderDetailSkeleton = (): ReactElement => (
  <div>
    <p role="status" className="sr-only">
      주문을 불러오는 중입니다.
    </p>
    <div aria-hidden className="flex flex-col gap-10">
      <div className="h-24 w-full max-w-md animate-pulse bg-muted/70" />
      <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] xl:gap-16">
        <div className="aspect-square w-full animate-pulse bg-muted/70" />
        <div className="min-h-96 animate-pulse bg-muted/70" />
      </div>
    </div>
  </div>
);
